import React, { useState, useEffect } from 'react';
import {
    Paper,
    FormControl,
    TextField,
    Typography,
    FormGroup,
    Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';
import Common from '../Common';
import { withCookies } from 'react-cookie';
import CreateButton from './CreateButton';
import CategoryTable from './CategoryTable';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles({
    paper: {
        marginTop: '5px',
        minWidth: 1050,
        textAlign: 'center',
        justifyContent: 'center',
    },
    inputNickName: {
        marginTop: '30px',
        alignItems: 'center',
        justifyContent: 'center'
    },
    attention: {
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '300px'
    },
    categorySelect:{
        margin: '15px 7px 0px 22px',
    },
    conditionLeft: {
        width: '400px',
        fontSize:'20px',
    },
    categoryName:{
        borderBottom: 'solid 2px #FFF',
        fontSize:'19px',
        marginRight: '300px',
    },
    title:{
        marginLeft: '30px',
        marginTop: '30px',
        justifyContent: 'center',
        textAlign:'center'
    },
    inputKeyword:{
        fontSize:'20px',
        margin: '20px 0px 10px 180px',
        width: 200
    },
    createButton:{
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'100px'
    },
    table:{
        alignItems: 'center',
        justifyContent: 'center',
    },
    categoryLabel: {
        textAlign: 'left',
        fontSize:'20px',
        margin: '0px 0px 10px 270px',
        width: 200
    },
    noteLabel: {
        textAlign: 'left',
        fontSize:'15px',
        margin: '0px 0px 10px 400px',
        width: 500
    },
    inputNote:{
        fontSize:'20px',
        margin: '20px 0px 10px 30px',
    },
    note:{
        width: '400px',
        fontSize:'20px',
    },
    paging: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    created:{
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'675px'
    },
    createdDisplay:{
        fontSize:'18px',
        alignItems: 'left',
        justifyContent: 'left',
    },
    left:{
        display: 'inline-block',
    },
    marginAuto:{
        margin: '0px auto 10px 5px'
    }
});
const Category = withCookies((props) => {
    const classes = useStyles();
    const [chatCategoryList, setChatCategoryList] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [note, setNote] = useState('');
    const [switchStatus, setSwitchStatus] = useState('');
    const [page, setPage] = React.useState(1); //ページ番号
    const [pageCount, setPageCount] = React.useState(); //ページ数
    const [allItems, setAllItems] = React.useState([]); //全データ
    const [displayedItems, setDisplayedItems] = React.useState([]); //表示データ
    const [memoRequired, setMemoRequired] = React.useState(false); //備考欄を必須にするか
    const displayNum = 5; //1ページあたりの項目数

    const { cookies } = props;
    const commonNameObj = cookies.get('COMMON_NAME_OBJ');
    document.title = commonNameObj !== undefined ? commonNameObj.CHAT_NAME : '1対1チャット';
    const createCategoryNameObj = cookies.get('CREATE_CATEGROY_NAME_OBJ');
    const chatName = commonNameObj !== undefined ? commonNameObj.CHAT_NAME : '1対1チャット';
    const kubunName = commonNameObj !== undefined ? commonNameObj.KUBUN_NAME : 'チャットカテゴリ';
    const bikoName = createCategoryNameObj !== undefined ? createCategoryNameObj.BIKO_NAME : '備考欄';
    const bikoDescription = createCategoryNameObj !== undefined ? createCategoryNameObj.BIKO_DESCRIPTION : '';
    const nameObj = {
        'CHAT_NAME' : chatName,
        'KUBUN_NAME': kubunName,
        'BIKO_NAME': bikoName,
        'BIKO_DESCRIPTION': bikoDescription
    };

    //-----------------------------------------------------------------
    //              ページに格納するデータの取得
    //-----------------------------------------------------------------
    function getCategoryData() {
        if(chatCategoryList.length === 0){
            const token = cookies.get('token');
            const jichitaiToken = cookies.get('x-jichitai-token');
            const jichitaiId = cookies.get('x-jichitai-jichitaiid');
            const supportedPersonId = cookies.get('supportedPersonId');

            axios.get(
            `${Common.apiServerUrl()}/api/counseling/getResponsibleKubun`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {
                    supportedPersonId
                }
            })
            .then(Common.handleErrors)
            .then((getResponsibleKubunResponse) => {
                if (getResponsibleKubunResponse.success) {
                    //担当区分が返却された場合のみ割り当てる
                    if (getResponsibleKubunResponse.getResponsibleKubunArray.length !== 0){
                        let categoryArray = getResponsibleKubunResponse.getResponsibleKubunArray.filter((d) => d.counselingKubunId !== '00');
                        categoryArray = categoryArray.filter((data) => data.counselingKubunId !== '00' && data.counselingKubunId !== 'all');
                        categoryArray.sort((a, b) => {
                            if(a.createTime >= b.createTime) return -1;
                            else return 1;
                        });
                        setChatCategoryList(categoryArray);
                        setSwitchStatus(getResponsibleKubunResponse.switchStatus);
                        const memoRequiredFlg = getResponsibleKubunResponse.memoRequired === 'TRUE' ? true : false;
                        setMemoRequired(memoRequiredFlg);
                    }
                    //対応：ここのsetStateは担当区分がない場合にはERRORになる
                } else {
                    alert(`code : [${getResponsibleKubunResponse.code}]\nmessage : ${getResponsibleKubunResponse.error_usermsg}`);
                }
            })
            .catch((err) => {
                console.log(err);
                if (Object.keys(err).indexOf('data') !== -1) {
                    alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
                } else {
                    alert('code : [getResponsibleKubun]\nmessage : エラーが発生しました。サポートに連絡してください。');
                }
            });
        }
    }

    useEffect(() => {
        if(cookies.get('supporterFullName') === undefined || cookies.get('supporterFullName') === ''){
            window.location.href = '/';
        }
        else if(chatCategoryList.length === 0) getCategoryData();
    },[]);

    useEffect(() => {
        setAllItems(chatCategoryList);
        //ページカウントの計算
        setPageCount(Math.ceil(chatCategoryList.length / displayNum));
        //表示データを抽出
        setDisplayedItems(chatCategoryList.slice(((page - 1) * displayNum), page * displayNum));
    }, [chatCategoryList]);

    const handleChange = (_event, index) => {
        //ページ移動時にページ番号を更新
        setPage(index);
        //ページ移動時に表示データを書き換える
        setDisplayedItems(allItems.slice(((index - 1) * displayNum), index * displayNum));
    };

    return (
        <React.Fragment>
            <div elevation={3} className={classes.paper} >
                <div className={classes.left}>
                    <Typography className={classes.title} variant="h4" component="p">
                        {`${nameObj.CHAT_NAME}作成依頼`}
                    </Typography>
                    <Paper elevation={2} variant="outlined" className={classes.paper}></Paper>
                    <FormGroup className={classes.inputNickName} row>
                        <Typography variant="body1" className={classes.inputKeyword}>
                            {`${nameObj.KUBUN_NAME}：`}
                        </Typography>
                        <div className={classes.marginAuto}>
                            <React.Fragment>
                                <FormControl className={classes.categorySelect}>
                                    <TextField
                                        id="outlined-basic"
                                        variant="outlined"
                                        className={classes.conditionLeft}
                                        margin="normal"
                                        value={categoryName}
                                        onChange={(event) => setCategoryName(event.target.value)}
                                        inputProps={{
                                            maxLength: 20
                                        }}
                                    />
                                </FormControl>
                            </React.Fragment>
                        </div>
                    </FormGroup>
                    <FormGroup className={classes.attention} row>
                        <Typography variant="body5" className={classes.categoryLabel}>
                            {'※20文字以下'}
                        </Typography>
                    </FormGroup>
                    <FormGroup className={classes.inputNickName} row>
                        <Typography variant="body1" className={classes.inputKeyword}>
                            {`${nameObj.BIKO_NAME}：`}
                        </Typography>
                        <div className={classes.marginAuto}>
                            <React.Fragment>
                                <FormControl className={classes.categorySelect}>
                                    <TextField
                                        multiline
                                        id="outlined-basic"
                                        variant="outlined"
                                        className={classes.note}
                                        required={memoRequired}
                                        margin="normal"
                                        value={note}
                                        rows={4}
                                        onChange={(event) => setNote(event.target.value)}
                                    />
                                </FormControl>
                            </React.Fragment>
                        </div>
                    </FormGroup>
                    <FormGroup row>
                    <Typography variant="body5">
                        {nameObj.BIKO_DESCRIPTION.split('\n').map((line) => {
                            return (
                                <div className={classes.noteLabel}>{line}</div>
                            )
                        })}
                    </Typography>
                    </FormGroup>
                    <FormGroup className={classes.createButton} row>
                        <CreateButton
                            categoryName={categoryName}
                            note={note}
                            nameObj={nameObj}
                            memoRequired={memoRequired}
                        >
                        </CreateButton>
                    </FormGroup>
                    <FormGroup className={classes.created} row>
                        <Typography variant="body5" className={classes.createdDisplay}>
                            一覧：
                        </Typography>
                    </FormGroup>
                    <FormGroup className={classes.table} row>
                        <CategoryTable
                            categoryList={displayedItems}
                            switchStatus={switchStatus}
                            nameObj={nameObj}
                        />
                        <Grid container item justify="center" alignItems="center" className={classes.paging}>
                            <Pagination count={pageCount} page={page} size="large" color="primary" onChange={handleChange} />
                        </Grid>
                    </FormGroup>
                </div>
            </div>
        </React.Fragment>
    );
});

export default withCookies(Category);
